import { Component, Input } from '@angular/core';
import { ReturnItem } from '../returnItem';
import { ReturnsService } from '../returns.service';

@Component({
  selector: 'tr[app-return-item-line]',
  templateUrl: './return-item-line.component.html',
  styleUrls: ['./return-item-line.component.scss'],
})
export class ReturnItemLineComponent {
  @Input() returnItem!: ReturnItem;
  @Input() index!: number;

  updated: boolean = false;
  success: boolean = true;

  constructor(private returnsService: ReturnsService) {}

  updateReturnItem(returnItem: ReturnItem) {
    this.returnsService.setProcessed(returnItem).subscribe({
      next: () => {
        this.updated = true;
        this.success = true;
      },
      error: (error: Error) => {
        console.error(error);
        this.updated = true;
        this.success = false;
      },
    });
  }
}
